<template>
  <!--消费记录页面-->
  <tk-container :empty-message="'暂无消费记录数据'" :status="status" @refresh="getInit">
    <!--头部-->
    <my-header slot="header">
      消费记录
      <!--终端添加客户-->
      <div slot="right-menu" v-if="isTerminalAccount">
        <div @click="customerShow = true">
          <tk-icon size="24" material>add</tk-icon>
        </div>
      </div>
    </my-header>
    <!--消费列表-->
    <div v-if="!isTerminalAccount" style="height: 12px"></div>
    <div v-if="isTerminalAccount && customerData.length">
      <div
        v-for="(s, index) in customerData"
        :key="index"
      >
        <tk-card :height="100" :width="100" is-middle is-between>
          <div class="tk-grid-10">
            <tk-flex middle class="font-13 full-width">
              <div class="label-color tk-grid-3">消费金额：</div>
              <div class="font-bold tk-grid-9 font-14">
                <span class="font-10">￥</span>{{s.consumerAmount}}
              </div>
            </tk-flex>
            <tk-flex middle class="font-13 m-t-15 full-width">
              <div class="label-color tk-grid-3">消费时间：</div>
              <div class="tk-grid-9">{{s.createdAt | datetime}}</div>
            </tk-flex>
            <tk-flex class="font-13 m-t-15 full-width">
              <div class="label-color tk-grid-3">消费内容：</div>
              <div class="tk-grid-9 class-card-wrap">{{s.consumerContent}}</div>
            </tk-flex>
          </div>
          <div class="tk-grid-2 text-right" @click="selectedCustomer(s)">
            <tk-icon size="20" :color="'#AFB1B8'">delete</tk-icon>
          </div>
        </tk-card>
        <div class="card-line"></div>
      </div>
    </div>
    <div v-else-if="customerData.length && !isTerminalAccount">
      <div
        v-for="(s, index) in customerData"
        :key="index"
        :class="{'m-t-12': index > 0}"
        class="m-x-12"
      >
        <tk-card :height="100" :width="100" is-middle is-column>
          <tk-flex middle class="font-13 full-width">
            <div class="label-color tk-grid-3">消费金额：</div>
            <div class="font-bold tk-grid-9 font-14">
              <span class="font-10">￥</span>{{s.orderAmount}}
            </div>
          </tk-flex>
          <tk-flex middle class="font-13 m-t-15 full-width">
            <div class="label-color tk-grid-3">消费时间：</div>
            <div class="tk-grid-9">{{s.createdAt | datetime}}</div>
          </tk-flex>
          <tk-flex class="font-13 m-t-15 full-width">
            <div class="label-color tk-grid-3">消费内容：</div>
            <div class="tk-grid-9 class-card-wrap" v-if="s.commodityData">{{'购买了' + s.commodityData[0].productTitle + '等商品'}}</div>
          </tk-flex>
        </tk-card>
      </div>
    </div>
    <!--添加消费记录弹框-->
    <tk-cover
      :show.sync="customerShow"
      bottom
      transition
    >
      <card :width="100" style="border-radius: 10px 10px 0 0;" :height="215">
        <tk-flex middle between class="p-b-15">
          <div class="font-bold">添加消费记录</div>
          <action-button
            @click.native="submitCustomer"
            :disabled="applyDisabled"
            :btn-text="'提交'"
            :is-border="false"
            :text-color="'#fff'"
            :bg-color="'#D84342'"
            :min-width="80" :height="35" is-raised
          ></action-button>
        </tk-flex>
        <tkui-form ref="form">
          <!--消费内容-->
          <div class="account-basic-input">
            <tkui-input v-model="consumerContent" rulers="required" label="消费内容" placeHolder="请输入消费内容"></tkui-input>
          </div>
          <!--消费金额-->
          <div class="account-basic-input">
            <tkui-input v-model="consumerAmount" type="number" mask="decimal:2" rulers="required" label="消费金额" placeHolder="请输入消费金额"></tkui-input>
          </div>
        </tkui-form>
      </card>
    </tk-cover>
    <!--确认删除弹框-->
    <tkui-dialog :show.sync="isShowDelete" center>
      <div class="subhead">
        您确定要删除该条消费记录吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowDelete = false">取消</button>
        <button class="tkui-dialog-button primary" :disabled="spinnerLoading" @click="sureDelete">确定</button>
      </template>
    </tkui-dialog>
  </tk-container>
</template>

<script>
// import { floatingPoint } from '@/assets/help/tool'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      customerShow: false, // 消费记录弹框
      applyDisabled: false, // 提交按钮状态
      consumerContent: '', // 消费内容
      consumerAmount: '', // 消费金额
      deleteCustomer: null, // 要删除的数据
      isShowDelete: false, // 删除的状态
      spinnerLoading: false, // 删除按钮状态
      customerData: [] // 消费数据
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
     * @Description: 页面初始化
     * @author xiaozan
     * @date 2020/5/6
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getCustomerDetail() // 获取消费记录
        if (!this.customerData.length) {
          this.status = 'empty'
          return
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * @Description: 获取消费记录
     * @author xiaozan
     * @date 2020/5/6
     */
    async getCustomerDetail () {
      if (this.isTerminalAccount) {
        let consumptionRecords = await this.$tkParse.getList('/classes/consumptionRecords', {
          params: {
            limit: 20000,
            order: '-createdAt',
            where: {
              client: this.$route.query.id,
              user: this.userInfo.objectId
            }
          }
        })
        if (consumptionRecords.length) {
          this.customerData = consumptionRecords
        } else {
          this.customerData = []
        }
      } else {
        let order = await this.$tkParse.getList('/classes/order', {
          params: {
            limit: 20000,
            order: '-createdAt',
            where: {
              buyUser: this.$route.query.id,
              merchants: this.userInfo.objectId,
              status: { $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped'] }
            }
          }
        })
        if (order.length) {
          this.customerData = order
        } else {
          this.customerData = []
        }
      }
    },
    /**
    * 添加客户消费记录
    * @date: 2020/5/20
    */
    async submitCustomer () {
      let res = this.$refs.form.validate()
      if (res.length > 0) {
        this.$tkGlobal.toast.add('请检查您填写的内容是否正确')
        return
      }
      try {
        this.status = 'waiting'
        this.customerShow = false
        this.applyDisabled = true
        await this.$tkParse.post('/classes/consumptionRecords', {
          user: this.userInfo.objectId,
          client: this.$route.query.id,
          consumerAmount: Number(this.consumerAmount),
          consumerContent: this.consumerContent
        })
        // let myClient = await this.$tkParse.getData(`/classes/myClient/${this.$route.query.id}`)
        // await this.$tkParse.put(`/classes/myClient/${this.$route.query.id}`, {
        //   consumption: floatingPoint(myClient.consumption, Number(this.consumerAmount), 'add')
        // })
        await this.getInit()
        await this.$tkHelper.sleep(500)
        this.$setFlash('addStatus', true)
        this.$tkGlobal.toast.add('添加记录成功')
        this.status = false
        this.applyDisabled = false
      } catch (e) {
        this.status = false
        this.customerShow = false
        this.applyDisabled = false
        this.$tkGlobal.toast.add('添加记录失败')
      }
    },
    /**
     * 删除客户消费记录
     */
    async selectedCustomer (s) {
      this.deleteCustomer = s
      this.isShowDelete = true
    },
    /**
     * 确定删除客户消费记录
     */
    async sureDelete () {
      this.spinnerLoading = true
      this.isShowDelete = false
      try {
        let s = this.deleteCustomer
        // let myClient = await this.$tkParse.getData(`/classes/myClient/${this.$route.query.id}`)
        // await this.$tkParse.put(`/classes/myClient/${this.$route.query.id}`, {
        //   consumption: floatingPoint(myClient.consumption, Number(s.consumerAmount), 'subtract')
        // })
        await this.$tkParse.delete(`/classes/consumptionRecords/${s.objectId}`)
        this.$setFlash('addStatus', true)
        await this.getInit()
        await this.$tkHelper.sleep(500)
        this.spinnerLoading = false
        this.$tkGlobal.toast.add('删除消费记录成功')
      } catch (e) {
        this.spinnerLoading = false
        throw this.$tkGlobal.toast.add('删除消费记录失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .tk-container-content .tk-container-cover {
    z-index: 111 !important;
  }
  .label-color {
    color: #999;
  }
  .delete-button {
    height: 100%;
  }
  /*分割线样式*/
  .card-line {
    height: 1px;
    width: 100%;
    background: #f5f5f5;
  }
</style>
